import { render } from "./ServicesSlider.vue?vue&type=template&id=7b922d6a&scoped=true"
import script from "./ServicesSlider.vue?vue&type=script&lang=js"
export * from "./ServicesSlider.vue?vue&type=script&lang=js"

import "./ServicesSlider.vue?vue&type=style&index=0&id=7b922d6a&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b922d6a"]])

export default __exports__